var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({attrs:{"label":_vm.label,"outlined":"","dense":"","clearable":"","single-line":"","hide-details":"","append-icon":"mdi-magnify"}},'v-text-field',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }